import React from 'react'
import styled from '@emotion/styled'

const SyledTableHeader = styled.th`
  background-color: white;
  z-index: 1;
  position: sticky;
  top: 0;
  background-color: 'white' !important;
  z-index: 1;

  &:last-of-type {
    text-align: center;
  }
`

type Props = {
  title: string
}

const TableHeader = ({ title }: Props) => <SyledTableHeader>{title}</SyledTableHeader>

TableHeader.defaultProps = {
  title: ''
}

export default TableHeader
